import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import Bubble from '@Shared/Bubble';
import Fader from '@Shared/Fader';
import Paginator from '@Shared/Paginator';
import { IEvent, IOrg } from '@src/interfaces';
import React, { useEffect, useState } from 'react';
import { Col, Form, ListGroup, Row } from 'react-bootstrap';
import GetStartedOrg from './Org';
import useSiteConfig from '@components/Hooks/useSiteConfig';

interface Props {
  setter: (org_id: number | null) => void
}

const GetStartedOrgs: React.FC<Props> = (props) => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const [page, setPage] = useState<number>(1);
  const [keyword, setKeyword] = useState<string>('');
  const [selected, setSelected] = useState<number | null>(null);
  const site_config = useSiteConfig();

  useEffect(() => {
    if (site_config?.domain) {
      api.getOrgs(1, site_config?.domain, '');
    }
  }, [site_config]);

  const search = (e: IEvent): void => {
    api.getOrgs(1, site_config!.domain, e.currentTarget.value);
    setPage(1);
    setKeyword(e.currentTarget.value);
    setOrg(null);
  }

  const updatePage = (num: number): void => {
    api.getOrgs(num, site_config!.domain, keyword);
    setPage(num);
    setOrg(null);
  }

  const setOrg = (org_id: number | null) => {
    setSelected(org_id);
    props.setter(org_id);
  }

  const getPageCount = () => {
    return Math.max(Math.ceil((store.orgs?.count ?? 0) / 10), 1);
  }

  return (
    <>
      <Row>
        <Col xs={2} sm={1}>
          <Bubble>1</Bubble>
        </Col>
        <Col xs={10} sm={11}>
          <h2>Find and Highlight YOUR Organization</h2>
          <Form.Group className='form-group'>
            <Form.Control type='text' onChange={search} placeholder='Search' />
          </Form.Group>
          <Form.Group className='form-group'>
            <Paginator
              totalPages={getPageCount()}
              currentPage={Math.min(page, getPageCount())}
              onChange={updatePage}
            />
          </Form.Group>
          <Form.Group className='form-group'>
            <Fader>
              {!!store.orgs && (
                <ListGroup
                  className={'icon-list ' + (store.orgs?.count ? 'light-shadow' : '')}
                >
                  {store.orgs?.orgs.map((org: IOrg) => {
                    return (
                      <GetStartedOrg key={org.id} node={org} active={selected} setter={setOrg} />
                    )
                  })}
                </ListGroup>
              )}
            </Fader>
          </Form.Group>
        </Col>
      </Row>
      {site_config?.domain == 'SUNCOM' && (
        <Row>
          <Col xs={2} sm={1}></Col>
          <Col xs={10} sm={11}>
            <p><a href="/start_snsa/">{"Can't find your organization? Click here."}</a></p>
          </Col>
        </Row>
      )}
    </>
  );
}

export default GetStartedOrgs;